/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../spine/options_pb.js');
var spine_client_query_pb = require('../../spine/client/query_pb.js');
goog.exportSymbol('proto.spine.web.WebQuery', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.web.WebQuery = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.web.WebQuery, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.web.WebQuery.displayName = 'proto.spine.web.WebQuery';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.web.WebQuery.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.web.WebQuery.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.web.WebQuery} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.web.WebQuery.toObject = function(includeInstance, msg) {
  var f, obj = {
    query: (f = msg.getQuery()) && spine_client_query_pb.Query.toObject(includeInstance, f),
    deliveredTransactionally: jspb.Message.getFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.web.WebQuery}
 */
proto.spine.web.WebQuery.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.web.WebQuery;
  return proto.spine.web.WebQuery.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.web.WebQuery} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.web.WebQuery}
 */
proto.spine.web.WebQuery.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_client_query_pb.Query;
      reader.readMessage(value,spine_client_query_pb.Query.deserializeBinaryFromReader);
      msg.setQuery(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDeliveredTransactionally(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.web.WebQuery.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.web.WebQuery.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.web.WebQuery} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.web.WebQuery.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQuery();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_client_query_pb.Query.serializeBinaryToWriter
    );
  }
  f = message.getDeliveredTransactionally();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional spine.client.Query query = 1;
 * @return {?proto.spine.client.Query}
 */
proto.spine.web.WebQuery.prototype.getQuery = function() {
  return /** @type{?proto.spine.client.Query} */ (
    jspb.Message.getWrapperField(this, spine_client_query_pb.Query, 1));
};


/** @param {?proto.spine.client.Query|undefined} value */
proto.spine.web.WebQuery.prototype.setQuery = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.web.WebQuery.prototype.clearQuery = function() {
  this.setQuery(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.web.WebQuery.prototype.hasQuery = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool delivered_transactionally = 2;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.spine.web.WebQuery.prototype.getDeliveredTransactionally = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 2, false));
};


/** @param {boolean} value */
proto.spine.web.WebQuery.prototype.setDeliveredTransactionally = function(value) {
  jspb.Message.setProto3BooleanField(this, 2, value);
};


goog.object.extend(exports, proto.spine.web);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../known_type_parsers.js');

proto.spine.web.WebQuery.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.web.WebQuery.fromObject(jsObject);
};

proto.spine.web.WebQuery.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.web.WebQuery();
  
  if (obj.query !== undefined) {
    if (obj.query === null) {
      msg.setQuery(null);
    } else {
      let value = proto.spine.client.Query.fromObject(obj.query);
      msg.setQuery(value);
    }
  }
  
  if (obj.deliveredTransactionally !== undefined) {
    if (obj.deliveredTransactionally !== null) {
      let value = obj.deliveredTransactionally;
      msg.setDeliveredTransactionally(value);
    }
  }
  return msg;
};
